<template>
  <div>
	  <Header :sel='4' @changePhone="changePhone"/>
	  <!--neirong-->
	  <div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
	    <!-- your content here --> 
	    <div class="banner"> </div>
      <!--banner--> 
      
      <!--neirong-->
      <div class="bread_bg">
    <div class="bread"> <a href="javascript:void(0)" @click="goNext('/')">首页</a> - <a href="javascript:void(0)" @click="goNext('/newList')">公司新闻</a>- <a href="javascript:void(0)">{{ detail.title }}</a></div>
  </div>
      <div class="neirong">
          <div class="news_t">{{ detail.title }}</div>
        <div class="news_laiyuan">{{detail.publishDate}} </div>
        <div class="news_c" v-html="detail.content"></div>
		<div v-if="fileList&&fileList.length>0">
			<!-- <div>附件</div> -->
			<ul class="news-list">
				<li v-for='(item,index) in fileList' :key='index'>
					<div class="news-list-title">
						
						<img class="title-filetype"
							src="https://smrgonghui.oss-cn-beijing.aliyuncs.com/unionimg/img/filetype/pdf.png"
							v-if="item.fileSuffix=='.pdf'"></img>
						<img class="title-filetype"
							src="https://smrgonghui.oss-cn-beijing.aliyuncs.com/unionimg/img/filetype/word.png"
							 v-if="item.fileSuffix=='.doc'||item.fileSuffix=='.docx'"></img>
						<img class="title-filetype"
							src="https://smrgonghui.oss-cn-beijing.aliyuncs.com/unionimg/img/filetype/excel.png"
							 v-if="item.fileSuffix=='.xls'||item.fileSuffix=='.xlsx'"></img>
						<img class="title-filetype"
							src="https://smrgonghui.oss-cn-beijing.aliyuncs.com/unionimg/img/filetype/jpg.png"
							 v-if="item.fileSuffix=='.jpg'"></img>
						<img class="title-filetype"
							src="https://smrgonghui.oss-cn-beijing.aliyuncs.com/unionimg/img/filetype/png.png"
							 v-if="item.fileSuffix=='.png'"></img>
		
						<a :href="item.url" target="_blank">{{item.fileName}}</a>
					</div>
		
				</li>
			</ul>
		</div>
	
		
 <div class="pages">
 <div class="pages_up" v-if="prevArticle">
 <p>上一篇</p>
 <p><a href="javascript:void(0)" @click="goDetail(prevArticle.id)">{{prevArticle.title}}</a></p>
 </div>
  <div class="pages_next" v-if="nextArticle">
 <p>下一篇</p>
 <p><a href="javascript:void(0)" @click="goDetail(nextArticle.id)">{{nextArticle.title}}</a></p>
 </div>
 </div>
  </div>
		 <Footer/>
		</div>
	  
	  
	  
	  <!--neirong--> 
	  
   
  </div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import{getNewDetail,getNextAndPrev} from '@/api/reqFetch.js'
	
  export default {
  	name: '',
    layout: '',
	components: {
	  Footer,
	  Header
	},
  	data() {
  		return {
			id:'',
			detail:{},
			showPhone:false,
			prevArticle:{},
			nextArticle:{},
			fileList: [],
		}
  	},

  	mounted() {
	 this.id=this.$route.query.id
      this.getNewDetail();
	  this.getNextAndPrev()
  	},

  	methods: {
		goDetail(id) {
				this.id = id
				this.getNewDetail();
				this.getNextAndPrev()
			},

			getNextAndPrev() {
				getNextAndPrev({
					id: this.id
				}).then(res => {
					this.prevArticle = res.data.prevArticle
					this.nextArticle = res.data.nextArticle
				})
			},
		changePhone(val){
			this.showPhone=val
		},
		getNewDetail(){
			getNewDetail({id:this.id}).then(res => {
			    this.detail = res.data;
				this.fileList = res.data.fileList;
				document.title = this.detail.title + ' - ' +localStorage.getItem('webTitle')
			});
		},
		goNext(url){
			this.$router.replace({
				path:url,
			})
		}
     
  	}
  }
</script>

<style scoped>/*内容*/
.banner{
	background-image: url('../../assets/images/banner_04.png');
}
	.news-list{}
	.news-list li{ width: 100%;}
	.news-list-title{ display: flex;}
	.title-filetype{ width: 20px; height: 20px; margin-top: 8px; margin-right: 8px;}
</style>
